/**
 * @generated SignedSource<<4b8342c96ad0978a008ab7c025618a38>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UserContactStatus = "ELIGIBLE_FOR_ACTIVATION" | "NOT_TAKEN" | "UNVERIFIED" | "VERIFIED";
export type UserPhoneStatusInput = {
  phoneNumber: string;
};
export type useCheckUserPhoneStatusMutation$variables = {
  input: UserPhoneStatusInput;
};
export type useCheckUserPhoneStatusMutation$data = {
  readonly responsePayload: {
    readonly errors: ReadonlyArray<{
      readonly code: string;
      readonly field: ReadonlyArray<string | null | undefined>;
      readonly message: string;
    } | null | undefined>;
    readonly result: UserContactStatus | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type useCheckUserPhoneStatusMutation = {
  response: useCheckUserPhoneStatusMutation$data;
  variables: useCheckUserPhoneStatusMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "result",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "field",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v6 = {
  "alias": "message",
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useCheckUserPhoneStatusMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "UserPhoneStatusPayload",
        "kind": "LinkedField",
        "name": "userPhoneStatus",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCheckUserPhoneStatusMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "UserPhoneStatusPayload",
        "kind": "LinkedField",
        "name": "userPhoneStatus",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fb45ebcb6276d8a587fd839ba3f3e805",
    "id": null,
    "metadata": {},
    "name": "useCheckUserPhoneStatusMutation",
    "operationKind": "mutation",
    "text": "mutation useCheckUserPhoneStatusMutation(\n  $input: UserPhoneStatusInput!\n) {\n  responsePayload: userPhoneStatus(input: $input) {\n    success\n    result\n    errors {\n      __typename\n      field\n      code\n      message: code\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "54bded0b123f3a1a4e9acc17ef84e7d1";

export default node;
